import { Checkbox, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type TypeModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: ({ type }: { type: number | string }) => void;
};

export default function TypeModal({ open, onClose, onSubmit }: TypeModalProps) {
  const [checked, setChecked] = useState(1);
  const { t } = useTranslation();

  const plainOptions = [
    { value: 1, label: t('common.specification') },
    { value: 2, label: t('common.company-agreement') },
    { value: 3, label: t('common.implementation') },
  ];
  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({ type: checked });
  };

  const onChange = (val: number) => {
    setChecked(val);
  };

  return (
    <>
      <Modal
        title={t('common.regulation-type')}
        open={open}
        onOk={handleSubmit}
        onCancel={handleCancel}
        okText={t('common.confirm')}
        cancelText={t('common.cancel')}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20, margin: '20px 0' }}>
          {plainOptions?.map((item: { value: number; label: string }) => (
            <Checkbox
              key={item.value}
              checked={checked === item.value}
              onChange={() => onChange(item.value)}
            >
              {item.label}
            </Checkbox>
          ))}
        </div>
      </Modal>
    </>
  );
}
